import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXamarinComponent } from './simple-icons-xamarin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXamarinComponent ],
    exports:      [ SimpleIconsXamarinComponent ],
    bootstrap:    []
})
export class SimpleIconsXamarinModule {}
